import { createI18n } from "vue-i18n";
// eslint-disable-next-line camelcase
import de_DE from "@/i18n/locales/de_DE.json";
// eslint-disable-next-line camelcase
import en_US from "@/i18n/locales/en_US.json";

export const i18n = createI18n({
    locale: "en_US",
    fallbackLocale: "de_DE",
    messages: {
        // eslint-disable-next-line camelcase
        de_DE,
        // eslint-disable-next-line camelcase
        en_US
    }
});
